import React from 'react';

export function Jumbotron({ children, className = '', style = {}, ...props }) {
    return (
        <div className={`p-4 mb-4 bg-light rounded-3 ${className}`} style={style} {...props}>
            {children}
        </div>
    );
}
